{
  "id": "orcs",
  "name": "Orcs",
  "unitNames": {
    "worker": "Hauler",
    "melee": "Brute",
    "ranged": "Axe Thrower"
  },
  "buildingNames": {
    "town-center": "Great Hall",
    "barracks": "War Pit"
  }
}
